/*  livetable.js
	written by Clyde Brady Postma
	for Allmoxy, Inc.
	June 2008
	contact:  thepsudo@gmail.com
*/

function lTableInit(){
	var list = $$('.lTable');				// note uppercase 'T'
	list.each(ltPrepTables);
}
function ltFilter(e){
	var ltFilterSet = e.element().up('fieldset.filter,form.filter,div.filter');
	var lt = ltFilterSet.id.replace('-filter','');
	ltDelayedRequest(lt);
}
var ltRequestDelay = null;
// canon empty-state unblock (D19a): reset every filter control for this table and refetch.
// Text inputs (and their hidden *_sql date twins) empty, checkboxes/radios uncheck, selects
// return to their first option; the URL anchor re-serializes through the normal request flow.
// Also the rail's Clear control (canon filter-rail.css __clear, DEV-12500/12516/12538 wave 1).
// The chip-backed filters mirror their checked state onto label.am-chip through a change
// listener (m3_behaviors.js); a JS-set .checked fires nothing, so the chip class is synced
// here. Canon date-picker fields (m3_behaviors.js date-picker section) show the hidden
// ISO input's value in a span, so an emptied input drops its field back to the placeholder.
function lt_clear_filters(id){
	var f = $(id + '-filter');
	if(!f) return;
	f.select('input').each(function(inp){
		if(inp.type == 'text') inp.value = '';
		else if(inp.type == 'checkbox' || inp.type == 'radio'){
			inp.checked = false;
			var chip = inp.closest ? inp.closest('label.am-chip') : null;
			if(chip) chip.classList.remove('am-chip--selected');
		}
		else if(inp.type == 'hidden' && /_sql$/.test(inp.id || '')){
			inp.value = '';
			if(inp.hasAttribute('data-datepicker-input') && window.amDatepickerSync) window.amDatepickerSync(inp);
		}
	});
	f.select('select').each(function(s){ if(s.options.length) s.selectedIndex = 0; });
	ltDelayedRequest(id);
}
function ltDelayedRequest(id){
	if(ltRequestDelay) clearTimeout(ltRequestDelay);
	ltRequestDelay = setTimeout('tableAutoUpdate("'+id+'")',400);
}
function ltMouseEvents(o,i){	// initiate all per-table mouse events
	o.select('.ppp')[0].observe('change', function(){
		o.select('.curPage')[0].value = 1;
		ltDelayedRequest(o.id);
	});
	o.select('.curPage')[0].observe('keyup', function(){
		ltDelayedRequest(o.id);
	});
	var ltNums = o.select('.pager_numbers')[0];
	if(ltNums){
		ltNums.observe('click', function(e){
			var a = e.findElement('a.pager_num');
			if(!a) return;
			e.stop();
			o.select('.curPage')[0].value = a.readAttribute('data-page');
			ltDelayedRequest(o.id);
		});
	}
	o.select('.pager a').each(function(o1){
		o1.observe('click',function(){
			var oldPage = o.select('.curPage')[0].value;
			if(o1.href.match('#first')){
				o.select('.curPage')[0].value = 1;
			} else if(o1.href.match('#last')){
				var maxRow = parseInt(o.select('.maxPage')[0].innerHTML.replace(',',''));
				var perpageSelected = parseInt(o.select('.ppp')[0].value);
				var max = (maxRow / perpageSelected).ceil();
				o.select('.curPage')[0].value = max;
			} else if(o1.href.match('#prev')){
				var v = o.select('.curPage')[0].value - 1;
				if(!(v > 0)) return;
				o.select('.curPage')[0].value = v;
			} else if(o1.href.match('#next')){
				var maxRow = parseInt(o.select('.maxPage')[0].innerHTML.replace(',',''));
				var v = parseInt(o.select('.curPage')[0].value);
				var max = (maxRow / perpageSelected).ceil();
				if(v < max) return;
				o.select('.curPage')[0].value = v+1;
			}
			if(oldPage != o.select('.curPage')[0].value) ltDelayedRequest(o.id);
			var elem = document.getElementById(o.id);
			elem.scrollIntoView();
		});
	});
	o.select('.sortable').each(function(o1){
		o1.observe('click', ltSort);
	});
	//tableAutoUpdate(o.id);	// initial data population
}
function ltSort(){
	// 'this' should be the object clicked.
	if(this.hasClassName('asc')){
		this.addClassName('desc');
		this.removeClassName('asc');
	} else if(this.hasClassName('desc')){
		this.addClassName('asc');
		this.removeClassName('desc');
	} else {
		this.parentNode.childElements().each(function(o){
			o.removeClassName('asc');
			o.removeClassName('desc');
		});
		this.addClassName('asc');
	}
	// send ajax request here
	tableAutoUpdate(this.up('div').id);
}
var beenDone = false;
function ltPrep(o){
	//this function is depricated, htmlify_livetable_tbody() will automatically put in the right .even classes on the tr's and
	//the right .last class on the last visible td in the row.  if you want to have a class like .thin or .nowrap on the td then 
	//just put it in the row being built in php like this:
	// $row[] = array(
	// 	'value'=>$datum->get_name(),
	// 	'attributes' => array('class'=>'nowrap thin');
	// );
}
function filterAnchorCheck(uri){
	var u = uri;
	if(u.indexOf('#'))
		u = u.slice(0,uri.indexOf('#'));
	var v = window.location.href;
	if(v.indexOf('#'))
		v = v.slice(0,v.indexOf('#'));
	if(u == v){
		window.location.href = uri;
		window.location.reload();
		return false;
	}
}
function initFilterAnchor(id){
	var ob = $(id + '-filter'), where = {}, obj = [];
	var uri = decodeURIComponent(window.location.href.replace(new RegExp("[\+]", 'g'), ' '));
	if(uri.indexOf('#') > -1){
		var anchor = uri.slice(uri.indexOf('#')+1,uri.length); 
		var names = anchor.split('|');
		ob.select('input').each(function(ele){
			var match = false;
			if(!ele.name.blank()){
				names.each(function(name,i){
					if(ele.name == name.slice(0,ele.name.length)){
						var ind = name.indexOf('=');
						if(ind>-1){
							if('text'==ele.type){
								match = true;
								ele.value = name.slice(ind+1, name.length);
								return;
							} else {
								if(name.slice(ind+1,name.length).split(',').indexOf(ele.value) != -1){
									match = true;
									ele.checked = true;
									return;
								}
							}
						} else {
							ele.checked = match = true;
						}
					} 
				});
			}
			if(!match){
				if(ele.type == 'checkbox')
					ele.checked = false;
				else if(ele.type !== 'radio' && ele.type !== 'hidden')
					ele.value = '';
			}
		});
	} else {
		updateFilterAnchor(id);
	}
}
function updateFilterAnchor(id){
	var ob;
	if(typeof(id)=='string'){
		ob = $(id+'-filter');
	} else {
		ob = id.element().up('fieldset');
	}
	if(ob){
		var where = {}, obj = [], count = [];
		if(ob.select('input')){
			ob.select('input').each(function(inp){

				if(am.$('#'+id+'-filter').data('amckf') == true && inp.type == 'checkbox' && inp.name.length > 0 && !where[inp.name] && am.$("input:checkbox[name="+inp.name+"]:checked").length > 1){
					var temp = [];
					am.$("input:checkbox[name="+inp.name+"]:checked").each(function () {
						temp.push(am.$(this).val());
					});
					where[inp.name]=temp;
				}
				else{
					switch(inp.type){
						case 'text':
							if(!inp.value.blank()){
								where[inp.name]=escape(inp.value);
								count[inp.name]=2;
							}
							break;
						case 'checkbox': case 'radio':
							if(inp.checked){
								if(where[inp.name]){
									switch(typeof(where[inp.name])){
										case 'string':
											where[inp.name] = [where[inp.name]];
										case 'object':
											where[inp.name].push(inp.value);
											break;
									}
								} else {
									where[inp.name]=inp.value;
								}
							}
							if(count[inp.name]) count[inp.name]++; else count[inp.name]=1;
							break;
					}
				}
			});
		}
		if (ob.select('select')) {
			ob.select('select').each(function(inp) {
				if(!inp.value.blank()){
					where[inp.name]=escape(inp.value);
					count[inp.name]=2;
				}
			});
		}
	}
	var a = '#';

	for(var w in where){
		a += (count[w]>1?w+'='+where[w]:w)+'|';
	}
	var i;
	if((i = window.location.href.indexOf('#'))>-1){
		window.location.href = window.location.href.slice(0,i)+(a.length>1?a.slice(0,-1):a);
	} else if(a != '#'){
		window.location.href += a.slice(0,-1);
	}
}

// this function transforms lTables' appearance and installs Prototype.js observers for AJAX populating
// DEV-12318 QA: when the viewport is too narrow for the table's intrinsic width, the
// shell becomes a horizontal scroll container (.livetable--overflow, m3/_table.scss)
// instead of letting rows paint past the card edge. Toggled — never permanent — because
// a scroll container clips the absolute-positioned row-action menus, which is why
// .livetable carries no overflow by default.
// DEV-12855: the class this toggles changes the shell's OWN width (overflow-x +
// width:100% + clear:both, m3/_table.scss) and the ResizeObserver below watches that
// same shell - on width knife-edges add/remove re-triggered each other once per frame
// forever, a full-table layout per flip, pegging the main thread (the customer's
// Chrome 'Page Unresponsive'). The damper counts consecutive flips per shell: after 2
// in one burst it parks the shell in the SCROLLABLE state (rows never paint past the
// card edge) until the next explicit re-measure - the tableUpdateSuccess call sites
// pass reset=true on every content change, so real changes always settle fresh.
var ltOverflowFlips = {};
function ltCheckShellOverflow(tbl, reset){
	var shell = $(tbl);
	if(!shell || !shell.hasClassName('livetable')) return;
	var key = shell.id || String(tbl);
	if (reset) ltOverflowFlips[key] = 0;
	var want = shell.scrollWidth - shell.clientWidth > 1;
	var has = shell.classList.contains('livetable--overflow');
	if (want === has) { ltOverflowFlips[key] = 0; return; }
	ltOverflowFlips[key] = (ltOverflowFlips[key] || 0) + 1;
	if (ltOverflowFlips[key] > 2 && !want) return; // oscillating: stay scrollable
	shell.classList[want ? 'add' : 'remove']('livetable--overflow');
}
function ltPrepTables(o,i){
	o.hide();
	if(!o.hasClassName('lTable') || o.up('.livetable')) return;		// if already prepped, don't prep again.
	var id = o.id.replace('table_',''),vars=[30,1];
	if(o.getAttribute('title'))
		vars = o.getAttribute('title').split(':');
	// livetable--js marks shells whose tbody comes from htmlify_livetable_tbody() (which
	// flags numeric cells lt-nowrap); only those may carry the anywhere compress in
	// _table.scss — hand-written .livetable shells have no such protection (DEV-12875).
	var wrapper = o.wrap('div', { 'class': o.className.replace('lTable','livetable') + ' livetable--js', 'id': id, 'rel':o.getAttribute('rel') });
	// DEV-12318 QA: re-check the too-narrow state whenever the shell's own width changes
	// (viewport resize, rail collapse/expand). Content-driven changes are covered by the
	// explicit calls in tableUpdateSuccess.
	if (window.ResizeObserver) {
		// DEV-12855: coalesce deliveries to one check per frame - a delivery-time write
		// re-enters the observer within the same frame otherwise.
		var ltRoQueued = false;
		new ResizeObserver(function(){
			if (ltRoQueued) return;
			ltRoQueued = true;
			requestAnimationFrame(function(){ ltRoQueued = false; ltCheckShellOverflow(id); });
		}).observe(wrapper);
	}
	//TODO: Make the pager creator element-based
	var rowCount1 = 0;
	var rowCount2 = 0;
	var extraoption = '';
	if(o.getAttribute("data-addall")){
		extraoption = '<option value="999999999"'+(vars[0]==999999999?' selected':'')+'>All</option>'
	}
	var pager = 
	'<div class="pager">' +
		'<div class="rpp">' +
			'<span class="per_page_text">'+get_language_translation('LANG_ROWS_PER_PAGE')+' &nbsp; &nbsp;</span><select class="ppp"><option value="5"'+(vars[0]==5?' selected':'')+'>5</option><option value="15"'+(vars[0]==15?' selected':'')+'>15</option><option value="30"'+(vars[0]==30?' selected':'')+'>30</option><option value="50"'+(vars[0]==50?' selected':'')+'>50</option><option value="100"'+(vars[0]==100?' selected':'')+'>100</option>'+extraoption+'</select>&nbsp; &nbsp; &nbsp; &nbsp;' +
		'</div>' +
		'<div class="inPager">' +
		'<input type="text" class="curPage" style="display:none;" value="'+(vars[1]?vars[1]:'1')+'" size="1" maxlength="2" onchange="ltDelayedRequest(\''+id+'\')"/> <span class="rowcount1">' + (rowCount1) + '</span>-<span class="rowcount2">' + (rowCount2) + '</span> '+get_language_translation('LANG_OF')+' <var class="maxPage">10</var> &nbsp; &nbsp; &nbsp; &nbsp;' +
			'<span class="pager_nav" style="display:none;">' +
				'<a href="#first" id="pager_first" onclick="return false;">' +
					'<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"/></svg>' +
				'</a>' +
				'<a href="#prev" id="pager_prev" onclick="return false;">' +
					'<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>' +
				'</a>' +
				'<span class="pager_numbers"></span>' +
				'<a href="#next" id="pager_next" onclick="return false;">' +
					'<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>' +
				'</a>' +
				'<a href="#last" id="pager_last" onclick="return false;">' +
					'<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="m5.59 7.41 4.58 4.59-4.58 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"/></svg>' +
				'</a>' +
			'</span>' +
			'<span class="clear" style="display: none;"></span>' +
			'</div><div class="clear">' +
		'</div>' +
	'</div>';
	var header = '<table cellpadding="0" cellspacing="0" id="tbl_'+id+'" class="am-table">';
	if (o.down('colgroup'))
		header += o.down('colgroup').outerHTML;
	header += '<thead><tr>';
	var names = [];
	if (o.select('thead .sortable.asc,thead .sortable.desc').length > 0)
		var foundAny = true;
	else
		var foundAny = false;
	var alreadyOutputtedLastTH = false;
	o.select('thead td,thead th').each(function(o2,i2){
		var sortSt;
		if(o2.hasClassName('sortable')){
			sortSt = ' sortable';
			names[i2] = o2.getAttribute('rel');
			if (o2.hasClassName('desc'))
				sortSt += ' desc';
			else if (o2.hasClassName('asc'))
				sortSt += ' asc';
			else if(!foundAny){
				foundAny = true;
				sortSt += ' asc';
			}
		} else {
			sortSt = '';
		}

		header += ('<th '+(alreadyOutputtedLastTH?' style="display:none"':'')+' class="c'+i2+sortSt+(o2.hasClassName('nowrap')?' nowrap':'')+(o2.hasClassName('thin')?' thin':'')+(o2.hasClassName('last')?' last':'')+(o2.hasClassName('tal')?' tal':'')+(o2.hasClassName('tar')?' tar':'')+(o2.hasClassName('center')?' center':'')+(o2.hasClassName('two')?' two':'')+(i2==0?' first':((o2.next() || alreadyOutputtedLastTH)?'':' last'))+'">'+(sortSt?'<span>':'')+o2.innerHTML+(sortSt?'</span>':'')+'</td>');
		if(o2.hasClassName('last')){
			alreadyOutputtedLastTH = true;
		}
	});
	header += '</tr></thead><tbody></tbody></table>';
	o.insert({before:header});
	var ltNew = o.previous();
	ltNew.select('th.sortable').each(function(o3){
		o3.observe('mouseover', function(e){
			if(e.element().tagName != 'TH')
				var el = e.element().up('th');
			else
				var el = e.element();
			el.setOpacity(.95);
		});
		o3.observe('mouseout', function(e){
			if(e.element().tagName != 'TH')
				var el = e.element().up('th');
			else
				var el = e.element();
			el.setOpacity(1);
		});
	});
	o.remove();
	ltNew.select('th').each(function(o2,i2){
		if(names[i2]) o2.setAttribute('ajaxName',names[i2]);
	});
	ltNew.insert({'after':pager});
	ltMouseEvents($(id));
	if($(id+'-filter')) initFilterAnchor(id);
	tableAutoUpdate(id);
};
// DEV-12312: content-shaped loading state (canon skeleton, m3/_skeleton.scss).
// Fills the tbody with skeleton rows while the livetable fetch is in flight; the
// success path rewrites the tbody wholesale, which clears them. Row count follows
// the rows currently on screen so the table height doesn't jump; column count
// follows the live thead. Vanilla on purpose (no Prototype in new code).
function lt_show_skeleton(tblId){
	var t = document.getElementById(tblId);
	if(!t) return;
	var tbody = t.querySelector('tbody');
	if(!tbody) return;
	var cols = t.querySelectorAll('thead th').length;
	if(!cols) return;
	var rows = tbody.querySelectorAll('tr').length || 8;
	if(rows > 15) rows = 15;
	var widths = ['', ' am-skeleton--w-75', ' am-skeleton--w-60', ' am-skeleton--w-90'];
	var html = '';
	for(var r = 0; r < rows; r++){
		html += '<tr class="am-skeleton-lt-row">';
		for(var c = 0; c < cols; c++){
			html += '<td><div class="am-skeleton am-skeleton--line' + widths[(r + c) % widths.length] + '"></div></td>';
		}
		html += '</tr>';
	}
	tbody.innerHTML = html;
	if (typeof am_skeleton_takeover === 'function') am_skeleton_takeover();
}
function tableUpdate(params){
	//table, page, ppp, sortBy, sortDir, where){
	var tbl = params.table;
	lt_show_skeleton(tbl);
	if(!params.where)
		params.where = Object.toJSON(lt_read_filters(tbl));
	else
		params.where = Object.toJSON($H(eval('('+params.where+')')).update(lt_read_filters(tbl)));
	if(params.where && typeof(params.where)=='object')
		params.where = Object.toJSON(params.where);
	if(params.sortBy){
		if(params.sortDir != 'asc'){ params.sortDir = 'desc'; }	// force boolean
	} else {
		delete params.sortDir;
	}
	if(params.page < 1) params.page = 1;
	new Ajax.Request('ajax/livetable/',{
		parameters: params,
		onSuccess: function(ret){
			tableUpdateSuccess(ret, tbl, params);
		}
	});
}
function lt_read_filters(tbl){
	var wheres = {}, filter_set = $(tbl+'-filter');
	if(filter_set){
		if(filter_set.select('input')){
			filter_set.select('input').each(function(inp){
				if(('checkbox' == inp.type || 'radio' == inp.type) && inp.checked){
					if(!wheres[inp.name]) wheres[inp.name] = [];
					wheres[inp.name].push(inp.value);
                } else if ('hidden' == inp.type && inp.hasAttribute('data-lt-filter') && !inp.name.blank() && !inp.value.blank()) {
                    // canon date-picker fields (DEV-12516 wave 1): the hidden ISO input is
                    // the filter value and already carries the provider's key as its name
                    wheres[inp.name] = inp.value;
                } else if ('text' == inp.type && !inp.name.blank() && !inp.value.blank()) {
                    const date_field_sql = inp.closest('.date_row')?.querySelector(`#${inp.id}_sql`);

                    if (date_field_sql) {
                        let filter_value = date_field_sql.value;
                        wheres[inp.name] = filter_value;
                    } else {
                        wheres[inp.name] = inp.value;
                    }
                }
			});
		}
		if(filter_set.select('select')){
			filter_set.select('select').each(function(inp){
				if(!wheres[inp.name]) wheres[inp.name] = [];
				wheres[inp.name] = inp.value;
			});
		}
		return wheres;
	}
}
function tableUpdateSuccess(ret, tbl, params){
	var $tbl = $(tbl);
	if($(tbl+'-filter')){
		updateFilterAnchor(tbl);
	}
	var obj = ret.responseJSON;
	//Element.extend(obj);
	if(obj.ids_for_export)
		export_from_livetable.ids_for_export = obj.ids_for_export;
	else // force ID selection to actually refresh after changing date filter
		export_from_livetable.ids_for_export = null;
	if(obj.harvest_emails)
		harvest_emails.harvest_emails = obj.harvest_emails;
	if(!obj || !parseInt(String(obj.count).replace(/,/g,'')) || !obj.htmlified_tbody){ // count arrives as a string from some providers — "0" is truthy
		
		var c = $tbl.select('thead th').length;
		var result_msg = '';
        if (obj.hasOwnProperty('logged_out') && obj.logged_out)
			result_msg = '<div class="error" style="text-align: left;">'+get_language_translation('LANG_MSG_YOU_ARE_NO_LONGER_LOGGED_IN_EITHER_YOUR_SECESSION_EXPIRED_OR_YOU_LOGGED_OUT_IN_ANOTHER_WINDOW')+'.</div>';
		else if (obj && obj.error)
			result_msg = '<span class="error">' + (obj.error || '').escapeHTML() + '</span>';
		else
			result_msg = get_language_translation('LANG_TEXT_NO_RESULTS_FOUND');
		// canon no-results empty state (D19a): headline + supporting line + a clear-filters
		// unblock action. Error/logged-out branches keep their plain message. The pager's
		// result-count slot always gets the plain text, never the panel.
		var tbody_msg = result_msg;
		if(!(obj && obj.error) && !(obj.hasOwnProperty('logged_out') && obj.logged_out)){
			var lt_support = get_language_translation('LANG_MSG_TRY_REMOVING_A_FILTER');
			if(lt_support == 'Undefined') lt_support = 'Try removing a filter or widening the date range.';
			var lt_clear_lbl = get_language_translation('LANG_LABEL_CLEAR_ALL');
			if(lt_clear_lbl == 'Undefined') lt_clear_lbl = 'Clear all';
			tbody_msg = '<div class="am-table__empty">'
				+ '<div class="am-table__empty-headline">' + result_msg + '</div>'
				+ '<div class="am-table__empty-text">' + lt_support + '</div>'
				+ ($(tbl+'-filter') ? '<button type="button" class="am-btn am-btn--text am-table__empty-action" onclick="lt_clear_filters(\'' + tbl + '\');return false;">' + lt_clear_lbl + '</button>' : '')
				+ '</div>';
		}
		$tbl.select('tbody').first().update('<tr><td class="center first last" colspan="'+c+'">' + tbody_msg + '</td></tr>');
		$tbl.select('.pager .clear').first().update(result_msg);
		$tbl.select('.maxPage').first().update('1');
		$tbl.down('.pager').hide();

		// If the try to look at page 9 of 17 results showing 5 per page, send them to the last page of results (in this case, page 4)
		var perPage = $F($tbl.down('.ppp'));
		var currentPage = $tbl.down('.curPage');
		if((obj.count/perPage).ceil()< currentPage.value){
			currentPage.value = (obj.count/perPage).ceil();
			tableAutoUpdate(tbl);
		}
		ltCheckShellOverflow(tbl, true); // DEV-12318 QA: empty result can only shrink — clears the scroll state
		return;
	}
	$tbl.down('.pager').show();
	$tbl.select('.curPage').first().value = (obj.count < parseInt(obj.limit * obj.page)) ?  Math.ceil(obj.count / obj.limit) : obj.page;
	$tbl.select('.maxPage').first().update(Math.ceil(obj.count / Number(params.limit)));
	var maxPages = Number($tbl.select('.pager .maxPage').first().innerHTML);
	$tbl.down('.curPage').setAttribute('maxlength', maxPages.toString().length);
	$tbl.select('.pager .clear').first().update(number_format(obj.count) + ' result'+(1 == obj.count?'':'s')+' found.');
		setCounts($tbl, obj.page, Number(params.limit), number_format(obj.count));

		// Animate rows in with a staggered fade effect
		var ltNew = $tbl.down('tbody');
		var temp = document.createElement('div');
		temp.innerHTML = obj.htmlified_tbody;
		var newTbody = temp.querySelector('tbody');
		if (newTbody) {
			var rows = newTbody.querySelectorAll('tr');
			ltNew.update(''); // clear existing rows
			var STAGGER_MS = 25;   // delay between each row appearing
			var MAX_DELAY = 400;   // cap so large tables don't take forever
			for (var i = 0; i < rows.length; i++) {
				var row = rows[i];
				row.classList.add('lt-row-enter');
				var delay = Math.min(i * STAGGER_MS, MAX_DELAY);
				row.style.animationDelay = delay + 'ms';
				ltNew.appendChild(row);
			}
		} else {
			ltNew.replace(obj.htmlified_tbody);
		}
	
//this if/else was put it by ryan, we can take it out if we dont like it.
	//if there are less than thirty results dont show XX per page either
	//if there is only one page of results dont show « ‹ Viewing page  of 3 › »  (AKA .pager_nav)
	if(!maxPages || (maxPages == 1)) {
		$tbl.down('.pager .pager_nav').hide();
		//if there are less than thirty results dont show XX per page either
		[$tbl.down('.pager .ppp'), $tbl.down('.pager .per_page_text')].invoke((obj.count <= 15)?'hide':'show');	
	} else {
		[$tbl.down('.pager .pager_nav'), $tbl.down('.pager .ppp'), $tbl.down('.pager .per_page_text')].invoke('show');	
	}

	am.$('.pager').fadeTo("fast", 1);
	ltCheckShellOverflow(tbl, true); // DEV-12318 QA: fresh rows can change the table's intrinsic width
}
function tableAutoUpdate(tbl,where){
	$tbl = $(tbl);
	if($tbl){
		ltRequestDelay = null;
		var foundIt = false;
		$tbl.select('.sortable').each(function(o){
			if(foundIt) return;
			if(o.hasClassName('asc') || o.hasClassName('desc')){
				foundIt = o;
			}
		});
		where = where || $tbl.getAttribute('rel');
		if (foundIt) {
			var sortDir = foundIt.hasClassName('asc')?'asc':'desc';
			var sortBy = foundIt.getAttribute('ajaxName');
		}
		//if(!sortBy){ return; }	// if you don't know what its sorting by, don't change anything
		var myObjs = $tbl.select('.ppp');
		if(!myObjs.length) // This is not myObjs; it says, "Hroo!"
			return;
		var myObj = myObjs[0];
		var ppp = myObj.value;
		var options = {
			'table':tbl,
			'page':$tbl.down('.curPage').value,
			'limit':ppp,
			'where':where,
			'sortBy':sortBy,
			'sortDir':sortDir
		};
		if(('contacts' === tbl || 'companies' === tbl || 'people' === tbl)){
			options['harvest_emails'] = true;
			options['get_ids_for_export'] = true;
		}
		else if ('inventory' === tbl)
			options['get_ids_for_export'] = true;

		tableUpdate(options);
	}
}
function export_from_livetable(table){
	if(export_from_livetable.ids_for_export){
		get_export(table);
		return false;
	}
	var params = {};
	params.table = table;
	params.where = lt_read_filters(table);
	params.limit = 999999999;
	params.get_ids_for_export = true;
	new Ajax.Request('ajax/livetable/',{
		parameters: params,
		onSuccess: function(ret){
			export_from_livetable.ids_for_export = ret.responseJSON.ids_for_export;
			get_export(table);
		}
	});
	return false;
}
function get_export(table){
	if (!$('export_download_iframe')) {
		$('page').insert({after: '<iframe id="export_download_iframe" name="export_download_iframe" style="display:none"></iframe>'});
	}
	var form = new Element('form', {method: 'post', action: $$('base')[0].href + "export/" + table + "/", target: 'export_download_iframe'});
	form.insert({bottom: new Element('input', {type: 'hidden', name: 'ids', value: export_from_livetable.ids_for_export.join(",")})});
	$('page').insert({after: form});
	form.submit();
	form.remove();
}
function harvest_emails(table, type){
	html = '';
	if(type==null || type=='comma')
		html = harvest_emails.harvest_emails.join(', ');
	else if(type == 'semicolon')
		html = harvest_emails.harvest_emails.join('; ');
	else if(type == 'space')
		html = harvest_emails.harvest_emails.join('  ');

	open_modal('<p>Here are all the email addresses that match your search query.  Press CTRL+C to copy them to your clipboard. '
		+ 'Then you can paste them into the address line of your email program by pressing CTRL+V.</p>'
		+ '<div class="moxform"><textarea id="harvested_addresses" style="height:9em;">'
		+ html
		+ '</textarea></div>'
		+ '<select name="cars" id="cars" style="width: 20%; margin-left: 3%;" onchange="return harvest_emails(\'contacts\', this.value)">'
		+'<option value="">---Select---</option>'
		+'<option value="comma">Comma</option>'
		+'<option value="semicolon">Semicolon</option>'
		+'<option value="space">Space</option>'
	  	+'</select>'
		+ '<button type="button" style="margin-left: 54%;" class="am-btn am-btn--filled" onclick="copyToClipboard();">Copy</button>',
		{ title : 'E-Mail Addresses of ' + table.slice(0,1).toUpperCase() + table.slice(1), afterLoad: function()
			{
				$('harvested_addresses').focus();
				$('harvested_addresses').select(); 
			}
		}
	);
	return false;
}

function copyToClipboard(){
	let textarea = document.getElementById("harvested_addresses");
	textarea.select();
	document.execCommand("copy");
}

function setCounts(tbl, page, perpage, cnt){
	var cnt = parseInt(cnt.replace(',',''));
	if(page > 1){
		var num2 = page * perpage;
		var num1 = (num2-perpage)+1;
	}
	else{
		var num2 = perpage;
		var num1 = 1;
	}
	if(num2 > cnt)
		num2 = cnt;
	$tbl = $(tbl);
	if($tbl){
		$tbl.down('.rowcount1').innerHTML = number_format(num1);
		$tbl.down('.rowcount2').innerHTML = number_format(num2);
		$tbl.down('.maxPage').innerHTML = number_format(cnt);
		// canon pager numbers (D17a): 1 ... cur-1 cur cur+1 ... last, current as pill
		var ltNums = $tbl.down('.pager_numbers');
		if(ltNums){
			var ltPages = Math.ceil(cnt / perpage) || 1;
			var ltCur = parseInt(page) || 1;
			var ltHtml = '';
			var ltPrev = 0;
			for(var ltI = 1; ltI <= ltPages; ltI++){
				if(ltI != 1 && ltI != ltPages && (ltI < ltCur - 1 || ltI > ltCur + 1)) continue;
				if(ltI - ltPrev > 1) ltHtml += '<span class="pager_ellipsis">&hellip;</span>';
				ltHtml += '<a href="#page" class="pager_num' + (ltI == ltCur ? ' current' : '') + '" data-page="' + ltI + '" onclick="return false;"' + (ltI == ltCur ? ' aria-current="page"' : '') + '>' + ltI + '</a>';
				ltPrev = ltI;
			}
			ltNums.update(ltHtml);
		}
		if(num1 == 1){
			am.$('#pager_first').addClass('pager_disable');
			am.$('#pager_prev').addClass('pager_disable');
			am.$('#pager_last').removeClass('pager_disable');
			am.$('#pager_next').removeClass('pager_disable');
		}
		else{
			am.$('#pager_first').removeClass('pager_disable');
			am.$('#pager_prev').removeClass('pager_disable');

			if(num2 == cnt){
				am.$('#pager_last').addClass('pager_disable');
				am.$('#pager_next').addClass('pager_disable');
			}
			else{
				am.$('#pager_last').removeClass('pager_disable');
				am.$('#pager_next').removeClass('pager_disable');
			}
		}
	}
}